import { SmartPosBridge } from './SmartPosBridge';

class TicketGenerator {
  static generateTicket(order) {
    const date = new Date();
    const dateStr = date.toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });
    const timeStr = date.toLocaleTimeString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });

    // Logo SVG embedded directly
    const logoSVG = `<svg width="200" height="80" viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="200" height="80" rx="8" fill="#f8f9fa" stroke="#dee2e6" stroke-width="1"/>
      <text x="100" y="50" font-family="Arial, sans-serif" font-size="22" font-weight="bold" text-anchor="middle" fill="url(#logoGradient)">
        RIO HAUS
      </text>
      <circle cx="20" cy="40" r="3" fill="#667eea" opacity="0.6"/>
      <circle cx="180" cy="40" r="3" fill="#764ba2" opacity="0.6"/>
      <line x1="40" y1="70" x2="160" y2="70" stroke="#dee2e6" stroke-width="1"/>
    </svg>`;

    let ticketHTML = `
      <div class="ticket-header">
        <div style="text-align: center; margin-bottom: 10px;">
          ${logoSVG}
        </div>
        <p>Fecha: ${dateStr}</p>
        <p>Hora: ${timeStr}</p>
      </div>
      <div class="ticket-body">
    `;

    order.items.forEach((item, index) => {
      ticketHTML += `
        <div class="ticket-item">
          <span>${item.quantity}x ${item.article.name}</span>
        </div>
      `;
      if (index < order.items.length - 1) {
        ticketHTML += `<div class="ticket-separator">------------------------------------</div>`;
      }
    });

    ticketHTML += `
      </div>
      <div class="ticket-footer">
        <p>¡Gracias por su compra!</p>
      </div>
    `;

    return {
      html: ticketHTML,
      text: this.generateTextTicket(order),
      dataURL: null // Will be generated if needed for image export
    };
  }

  static generateTextTicket(order) {
    const date = new Date();
    const dateStr = date.toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });
    const timeStr = date.toLocaleTimeString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });

    let ticketText = `
====================================
           RIO HAUS
====================================
Fecha: ${dateStr}
Hora: ${timeStr}
------------------------------------
`;

    order.items.forEach(item => {
      const itemLine = `${item.quantity}x ${item.article.name}`;
      ticketText += itemLine + '\n';
    });

    ticketText += `
------------------------------------
¡Gracias por su compra!
====================================
`;

    return ticketText.trim();
  }

  static async generateImageTicket(order) {
    // This would use html2canvas to generate an image
    // For now, return the HTML structure
    return this.generateTicket(order);
  }

  static generateIndividualTicket(item) {
    const date = new Date();
    const dateStr = date.toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });
    const timeStr = date.toLocaleTimeString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' });

    // Logo SVG embedded directly
    const logoSVG = `<svg width="200" height="80" viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="200" height="80" rx="8" fill="#f8f9fa" stroke="#dee2e6" stroke-width="1"/>
      <text x="100" y="50" font-family="Arial, sans-serif" font-size="22" font-weight="bold" text-anchor="middle" fill="url(#logoGradient)">
        RIO HAUS
      </text>
      <circle cx="20" cy="40" r="3" fill="#667eea" opacity="0.6"/>
      <circle cx="180" cy="40" r="3" fill="#764ba2" opacity="0.6"/>
      <line x1="40" y1="70" x2="160" y2="70" stroke="#dee2e6" stroke-width="1"/>
    </svg>`;

    let ticketHTML = `
      <div class="ticket-header">
        <div style="text-align: center; margin-bottom: 10px;">
          ${logoSVG}
        </div>
        <p>Fecha: ${dateStr}</p>
        <p>Hora: ${timeStr}</p>
      </div>
      <div class="ticket-body">
        <div class="ticket-item">
          <span>${item.quantity}x ${item.article.name}</span>
        </div>
      </div>
      <div class="ticket-footer">
        <p>¡Gracias por su compra!</p>
      </div>
    `;

    let ticketText = `
====================================
           RIO HAUS
====================================
Fecha: ${dateStr}
Hora: ${timeStr}
------------------------------------
${item.quantity}x ${item.article.name}
------------------------------------
¡Gracias por su compra!
====================================
`;

    return {
      html: ticketHTML,
      text: ticketText
    };
  }

  static downloadTicket(ticketData, filename = 'ticket.txt') {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(ticketData.text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  static printTicket(ticketData) {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Imprimir Ticket</title>
            <style>
              body { 
                font-family: 'Courier New', monospace; 
                margin: 20px; 
                text-align: center;
              }
              .ticket { 
                border: 1px solid #000; 
                padding: 20px; 
                max-width: 300px; 
                margin: 0 auto;
                background: white;
              }
              .ticket-header { 
                border-bottom: 2px solid #000; 
                padding-bottom: 10px; 
                margin-bottom: 10px; 
              }
              .ticket-item { 
                display: flex; 
                justify-content: space-between; 
                margin: 5px 0; 
                text-align: left;
              }
              .ticket-footer { 
                border-top: 2px solid #000; 
                padding-top: 10px; 
                margin-top: 10px; 
              }
              @media print {
                body { margin: 0; }
                .ticket { border: none; }
              }
            </style>
          </head>
          <body>
            <div class="ticket">
              ${ticketData.html}
            </div>
            <script>
              window.onload = function() {
                window.print();
                window.close();
              }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    }
  }

  static async printDirect(ticketData) {
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Ticket</title>
          <style>
            @media print {
              @page {
                margin: 0;
                size: 80mm auto;
              }
              body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
            @media screen {
              body { 
                font-family: 'Courier New', monospace; 
                margin: 0; 
                padding: 4mm;
                text-align: center;
                background: white;
              }
            }
            .ticket { 
              width: 72mm;
              margin: 0 auto;
              background: white;
            }
            .ticket-header { 
              padding-bottom: 3mm; 
              margin-bottom: 3mm; 
            }
            .ticket-item { 
              display: flex; 
              justify-content: space-between; 
              margin: 5px 0; 
              text-align: left;
            }
            .ticket-separator {
              text-align: center;
              margin: 8px 0;
            }
            .ticket-footer { 
              padding-top: 10px; 
              margin-top: 10px; 
            }
          </style>
        </head>
        <body>
          <div class="ticket">
            ${ticketData.html}
          </div>
        </body>
      </html>
    `;
    
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.left = '-9999px';
    printFrame.style.top = '-9999px';
    printFrame.style.width = '80mm';
    printFrame.style.height = 'auto';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);
    
    const printDoc = printFrame.contentWindow.document;
    printDoc.open();
    printDoc.write(printContent);
    printDoc.close();

    const tryPrint = () => {
      try {
        printFrame.contentWindow.focus();
        printFrame.contentWindow.print();
      } catch (e) {
        console.error('Print failed:', e);
        alert('Error al imprimir. Por favor, seleccione la impresora manualmente.');
      }
    };

    if (printFrame.contentDocument.readyState === 'complete') {
      tryPrint();
    } else {
      printFrame.onload = tryPrint;
    }

    setTimeout(() => {
      if (document.body.contains(printFrame)) {
        document.body.removeChild(printFrame);
      }
    }, 5000);
  }

  static async printWithBluetoothToDevice(device, ticketData) {
    if (!device || !device.gatt) {
      return false;
    }

    try {
      let server;
      if (!device.gatt.connected) {
        server = await device.gatt.connect();
      } else {
        server = device.gatt;
      }
      const services = await server.getPrimaryServices();
      
      let printed = false;
      for (const service of services) {
        try {
          const characteristics = await service.getCharacteristics();
          for (const characteristic of characteristics) {
            try {
              const encoder = new TextEncoder();
              const data = encoder.encode(ticketData.text + '\n\n------------------------------------\n\n');
              await characteristic.writeValue(data);
              printed = true;
              break;
            } catch (e) {
              continue;
            }
          }
          if (printed) break;
        } catch (e) {
          continue;
        }
      }
      return printed;
    } catch (error) {
      console.error('Bluetooth print failed:', error);
      return false;
    }
  }

  static async printWithBluetooth(ticketData) {
    if (!navigator.bluetooth) {
      return false;
    }

    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: [
          '000018f0-0000-1000-8000-00805f9b34fb',
          '000018f0-0000-1000-8000-00805f9b34fb',
          'e7810a71-73ae-499d-8c15-faa9aef0c3f2',
          '49535343-fe7d-4ae5-8fa9-9fafd205e455'
        ]
      });

      const server = await device.gatt.connect();
      const services = await server.getPrimaryServices();
      
      for (const service of services) {
        try {
          const characteristics = await service.getCharacteristics();
          for (const characteristic of characteristics) {
            try {
              const encoder = new TextEncoder();
              const data = encoder.encode(ticketData.text);
              await characteristic.writeValue(data);
              await device.gatt.disconnect();
              return true;
            } catch (e) {
              continue;
            }
          }
        } catch (e) {
          continue;
        }
      }
      
      await device.gatt.disconnect();
      return false;
    } catch (error) {
      console.error('Bluetooth print failed:', error);
      return false;
    }
  }

  static downloadIndividualTicket(item, index) {
    const ticketData = this.generateIndividualTicket(item);
    const filename = `ticket_${item.article.id}_${index + 1}.txt`;
    this.downloadTicket(ticketData, filename);
  }

  static generateSimpleTicket(article) {
    const now = new Date();
    const dateStr = now.toLocaleDateString('es-ES', { timeZone: 'America/Argentina/Buenos_Aires' });
    const timeStr = now.toLocaleTimeString('es-ES', { timeZone: 'America/Argentina/Buenos_Aires', hour: '2-digit', minute: '2-digit' });
    const dateTimeLine = `${dateStr.padEnd(24, ' ')}${timeStr}`;

    let ticketHTML = `
      <div class="ticket-header">
        <div style="text-align: center; margin-bottom: 10px; font-size: 24px; font-weight: bold; color: #000;">
          RIO HAUS
        </div>
        <div style="display: flex; justify-content: space-between; margin: 4px 0; width: 100%;">
          <span>${dateStr}</span>
          <span>${timeStr}</span>
        </div>
      </div>
      <div class="ticket-body">
        <p style="font-weight: bold; font-size: 16px; margin: 10px 0;">${article.name}</p>
      </div>
      <div class="ticket-footer">
        <p style="margin: 8px 0;">¡Gracias por su compra!</p>
      </div>
    `;

    let ticketText = `================================
          RIO HAUS
================================
${dateTimeLine}
------------------------------------
${article.name}
------------------------------------
¡Gracias por su compra!
================================
`;

    return {
      html: ticketHTML,
      text: ticketText
    };
  }

  static async printWithFallback(ticketData) {
    // 1. Try the integrated SmartPos SDK first (Capacitor bridge)
    try {
      await SmartPosBridge.printTicket(ticketData.text);
      console.log('SmartPos SDK print success');
      return;
    } catch (smartPosError) {
      console.warn('SmartPos SDK print failed, falling back to Bluetooth:', smartPosError);
    }

    // 2. Fallback to Web Bluetooth (only works in browsers that support it)
    if (navigator.bluetooth) {
      try {
        const printed = await this.printWithBluetooth(ticketData);
        if (printed) {
          console.log('Bluetooth print success');
          return;
        }
        console.warn('Bluetooth print could not write to any characteristic, falling back to direct print');
      } catch (bluetoothError) {
        console.warn('Bluetooth print failed, falling back to direct print:', bluetoothError);
      }
    }

    // 3. Last resort: direct browser print
    await this.printDirect(ticketData);
  }
}

export default TicketGenerator;
